export class News {
    title:string= ''
    titleAr:string= ''
    body:string= ''
    bodyAr:string= ''
    videoUrl:string= ''
    date:string= '' 
    governoratesIds:[]=[]
    image:string= '' 
    creationDate:string= '' 
    keywordsNames:[]=[]
    ShowInHome:boolean;


}
export class UpdateourPartners {
    id:number=null
    title:string= ''
    body:string= ''
    videoUrl:string= ''
    date:string= '' 
    governoratesIds:[]=[]
    image:string= '' 
    creationDate:string= '' 
    keywordsNames:[]=[]




}